import type {UIResourceType} from '@wellstone-solutions/common/models/rest';
import type {ResourceFormValues} from './types';

const STRING_FIELDS = [
  'title',
  'subtitle',
  'description',
  'email',
  'phoneNumber',
  'website',
  'dateTimeInformation',
] as const;

const LOCATION_FIELDS = [
  'address',
  'address2',
  'city',
  'state',
  'zipcode',
] as const;

// Some older resources can return null for nullable string fields, so we normalize them to empty strings.
export const toFormValues = (resource: UIResourceType): ResourceFormValues => {
  const values = {...resource};

  STRING_FIELDS.forEach((field) => {
    values[field] = values[field] ?? '';
  });

  if (values.location) {
    const location = {...values.location};
    LOCATION_FIELDS.forEach((field) => {
      location[field] = location[field] ?? '';
    });
    values.location = location;
  }

  return values;
};
